"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSCarePackage_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSCarePackageCategory_1 = require("./NHSCarePackageCategory");
var NHSCarePackageCharge_1 = require("./NHSCarePackageCharge");
var NHSCarePackage_Factory = /** @class */ (function () {
    function NHSCarePackage_Factory() {
    }
    NHSCarePackage_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageId: model.CarePackageId,
            Code: model.Code,
            Description: model.Description,
            IsSignificantCode: model.IsSignificantCode,
            MaxInstances: model.MaxInstances,
            NHSCarePackageCategories: model.NHSCarePackageCategories && model.NHSCarePackageCategories.map(function (i) { return NHSCarePackageCategory_1.NHSCarePackageCategory_Factory.CreateIncoming(i); }),
            NHSCarePackageCharges: model.NHSCarePackageCharges && model.NHSCarePackageCharges.map(function (i) { return NHSCarePackageCharge_1.NHSCarePackageCharge_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    NHSCarePackage_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageId: model.CarePackageId,
            Code: model.Code,
            Description: model.Description,
            IsSignificantCode: model.IsSignificantCode,
            MaxInstances: model.MaxInstances,
            NHSCarePackageCategories: model.NHSCarePackageCategories && model.NHSCarePackageCategories.map(function (i) { return NHSCarePackageCategory_1.NHSCarePackageCategory_Factory.CreateOutgoing(i); }),
            NHSCarePackageCharges: model.NHSCarePackageCharges && model.NHSCarePackageCharges.map(function (i) { return NHSCarePackageCharge_1.NHSCarePackageCharge_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return NHSCarePackage_Factory;
}());
exports.NHSCarePackage_Factory = NHSCarePackage_Factory;
